import { AskKnowledge } from "../../features/ask-knowledge";
import { EmptyStateComponent } from "../../components/emptyState";

import styles from "./styles.module.scss";
import { useKnowledgeHub } from "../../features/wrapper/useKnowledgeHub";

export const KnowledgeHubPage = ({
  configurationToken,
}: {
  configurationToken: string;
}) => {
  const { config, loadingConfig } = useKnowledgeHub();

  if (!loadingConfig && !config)
    return (
      <EmptyStateComponent
        title="Oops! No configuration found"
        description="We seem to be unable to load the knowledge hub. Please contact support."
      />
    );

  return (
    // Remove ScrollArea here if the parent drawer/modal already provides one
    // or ensure this container fills the parent
    <div className={styles.container}>
      <div className={styles.content}>
        <AskKnowledge configurationToken={configurationToken} />
      </div>
    </div>
  );
};
